import React, { Fragment } from 'react';

import { cn } from '@/lib/utils';

import Card from '@/components/atoms/card/index';
import LinkButton from '@/components/atoms/linkButton';

import { Text } from '@/components/atoms/text';
import IconSupport from '~/svg/IconSupport.svg';

export type SideBannerProps = {
  title: string;
  description: React.ReactNode;
  image: React.ReactNode;
  items: {
    label?: string;
    href: string;
  }[];
  classNames?: {
    root?: string;
  };
};

export default function SideBanner({
  items,
  image,
  title,
  description,
  classNames,
}: SideBannerProps) {
  return (
    <Card
      classNames={{
        root: cn(
          'flex flex-col gap-3 dark:bg-transparent bg-transparent px-5 lg:px-6 lg:py-9 py-6',
          classNames?.root
        ),
      }}
      color='gradient'
    >
      <div className='flex items-center gap-4'>
        <div className={cn('flex flex-grow items-center gap-x-3 text-left')}>
          {!!image && image}
          <div className='space-y-3'>
            <Text variant='subtitle-l' color='neutral-N99'>
              {title}
            </Text>
          </div>
        </div>
      </div>
      {!!description && <Text color='neutral-N80'>{description}</Text>}

      <BannerActions items={items} />
    </Card>
  );
}

export function BannerActions({ items }: { items: SideBannerProps['items'] }) {
  return items.map((item, index) =>
    0 < index ? (
      <Fragment key={index}>
        <p className='text-neutral-N50 my-3 flex justify-center'>or</p>
        <LinkButton
          href={item.href}
          variant='outlined'
          color='secondary'
          fullwidth={true}
          leftSection={<IconSupport />}
        >
          {item.label}
        </LinkButton>
      </Fragment>
    ) : (
      <div key={index}>
        <LinkButton
          href={item.href}
          variant='filled'
          color='secondary'
          fullwidth={true}
        >
          {item.label}
        </LinkButton>
      </div>
    )
  );
}
